import { Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'src/Member/components/common/skeleton';

const MessageListSkeleton = () => {
  return (
    <>
      <Card className="p-3">
        <div className="d-flex mb-2">
          <Skeleton width={80} height={25} count={1} />
          <Skeleton width={80} height={25} count={1} className="ml-3" />
        </div>
        <Row className="">
          <Col>
            <Skeleton width="100%" height={70} count={5} className="my-1" />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default MessageListSkeleton;
